import globalApi from '../../api'

export const getChallengeParticipationTotalApi = ({ filter }) =>
  globalApi.post('/Challenge/ChallengeParticipationsTotal', { 
    ...filter, 
    isSecured: true 
  })

export const getChallengeParticipationTopWilayaApi = ({ filter }) =>
  globalApi.post('/Challenge/ChallengeParticipationsTopWilaya', {
    ...filter,
    isSecured: true,
  })

export const getChallengeParticipationTopDairaApi = ({ filter }) =>
  globalApi.post('/Challenge/ChallengeParticipationsTopDaira', {
    ...filter,
    isSecured: true,
  })

export const getChallengeParticipationPerWilayaApi = ({ filter }) =>
  globalApi.post('/Challenge/ChallengeParticipationsPerWilaya', {
    ...filter,
    isSecured: true,
  })

export const getChallengeParticipationPerDairaApi = ({ filter }) =>
  globalApi.post('/Challenge/ChallengeParticipationsPerDaira', {
    ...filter,
    isSecured: true,
  })

export const getChallengeParticipationPerStatusApi = ({ filter }) =>
  globalApi.post('/Challenge/ChallengeParticipationsPerStatus', {
    ...filter,
    isSecured: true,
  })

export const getComplaintCSVApi = ({ filter }) =>
  globalApi.post('/Reporting/GetComplaintsCSV', {
    ...filter,
    isSecured: true,
  })
